import { jsx as _jsx } from "react/jsx-runtime";
import { CookieConsentSettingState } from '@as-react/common-types';
import { connect } from 'react-redux';
import CookieMessage from '../components/common/cookie-message/CookieMessage';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import cookieConsentActions from '../redux/cookieConsent/actions/CookieConsentActions.creators';
import { makeGetCookieConsentSettingAvailable, makeGetCookieConsentSettings, } from '../redux/cookieConsent/selectors/CookieConsentSelector';
const CookieMessageContainer = ({ updateCookieConsentAction, analyticsCookieConsentAcceptAll, analyticsCookieConsentOpenPreferences, analyticsCookieConsentUpdated, cookieConsentSettingAvailable, cookieConsentSettings, logo, panel1, panel2, }) => {
    const cookieConsentAcceptAll = (consentSetting) => {
        updateCookieConsentAction(consentSetting);
        analyticsCookieConsentAcceptAll(consentSetting);
    };
    const cookieConsentUpdated = (consentSetting) => {
        updateCookieConsentAction(consentSetting);
        analyticsCookieConsentUpdated(consentSetting);
    };
    return (_jsx(CookieMessage, { cookieConsentAcceptAll: cookieConsentAcceptAll, analyticsCookieConsentOpenPreferences: analyticsCookieConsentOpenPreferences, cookieConsentUpdated: cookieConsentUpdated, cookieConsentSettingAvailable: cookieConsentSettingAvailable === CookieConsentSettingState.CONSENTS_AVAILABLE, cookieConsentSettings: cookieConsentSettings, logo: logo, panel1: panel1, panel2: panel2 }));
};
const makeMapStateToProps = () => {
    const getCookieConsentSettings = makeGetCookieConsentSettings();
    const getCookieConsentSettingAvailable = makeGetCookieConsentSettingAvailable();
    const mapStateToProps = (state) => ({
        cookieConsentSettings: getCookieConsentSettings(state),
        cookieConsentSettingAvailable: getCookieConsentSettingAvailable(state),
    });
    return mapStateToProps;
};
const mapDispatchToProps = {
    updateCookieConsentAction: cookieConsentActions.createSetAction,
    analyticsCookieConsentAcceptAll: analyticsActions.cookieConsentAcceptAll,
    analyticsCookieConsentOpenPreferences: analyticsActions.cookieConsentOpenPreferences,
    analyticsCookieConsentUpdated: analyticsActions.cookieConsentUpdated,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(CookieMessageContainer);
